// extracted by mini-css-extract-plugin
export default {"footer":"ImageView-module__[local]___GPLGu","img":"ImageView-module__[local]___rheJP"};